import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import { useMeta } from './hooks/useMeta';

function Gaia() {
  useMeta({
    title: 'Gaia - Inmaculada Fuentes',
    description: 'Gaia: Completa la trilogía sobre la conexión con la naturaleza. Libro bilingüe castellano-inglés por Inmaculada Fuentes.',
    image: '/portada_gaia.avif',
    url: 'https://inmaculadafuentes.com/gaia'
  });

  return (
    <div className="app">
      <Navbar showHomeLink />

      {/* Book Content */}
      <section className="book-page">
        <div className="book-hero">
          <img src="portada_gaia.avif" alt="Portada Gaia" className="book-hero-cover" />
          <h1>Gaia</h1>
          <p>Completa mi trilogía sobre la conexión con la naturaleza.</p>
        </div>

        <div className="book-section">
          <h2>Sobre Gaia</h2>
          
          <div className="quote">
            <p>"Hubo una vez una noche oscura llena de brillantes estrellas, en la que reinaba, a lo lejos, la Luna llena. Al caer sobre la Tierra, las estrellas y los planetas se convirtieron, inesperadamente, en hojas verdes, en coloridas flores y en salvajes frutos..."</p>
            <div className="quote-author">
              <strong>Inmaculada Fuentes</strong>
            </div>
          </div>
        </div>

        <div className="book-section">
          <h2>Información del libro</h2>
          <div className="book-info">
            <p><strong>Idea original, texto y edición:</strong> Inmaculada Fuentes Tomás</p>
            <p><strong>Ilustración:</strong> Laura Guiomar Mantecón</p>
            <p><strong>Traducción:</strong> María Teresa Manresa</p>
            <p><strong>Prólogo:</strong> José Luis Ferris</p>
            <p><strong>Edita:</strong> Mimadre Universe</p>
            <p><strong>ISBN:</strong> 978-84-09-56371-5</p>
            <p><strong>Tamaño:</strong> 25x25 cm</p>
            <p><strong>Páginas:</strong> 24</p>
            <p><strong>Características:</strong> Ilustrado a todo color, tapa dura</p>
            <p><strong>Papel:</strong> Pura celulosa ecológica ECF. Certificados FSC</p>
            <p><strong>Impresión:</strong> España - Printed in Spain</p>
            <p><strong>Otros idiomas:</strong> Inglés</p>
            <p><strong>Año:</strong> 2023</p>
            <p><strong>Características especiales:</strong> Libro bilingüe castellano-inglés</p>
            <p><strong>Accesibilidad:</strong> Letra para disléxicos. Letra grande</p>
            <p><strong>Compromiso:</strong> Agenda 2030</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Gaia;